import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { fetchCreditPlans, fetchWalletSummary } from '@/lib/api/wallet';

/** Credit balance of the signed-in user (unified reviews + writer wallet). */
export const useWallet = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['credit-wallet', user?.id],
    queryFn: fetchWalletSummary,
    enabled: !!user?.id,
    staleTime: 30_000,
  });
};

/** Public catalogue of subscription plans. */
export const useCreditPlans = () =>
  useQuery({
    queryKey: ['credit-plans'],
    queryFn: fetchCreditPlans,
    staleTime: 10 * 60_000,
  });
